module.exports = __webpack_public_path__ + "static/media/office.f0a5884f.jpg";